import { makeVar, InMemoryCache } from '@apollo/client'
import { gql } from '@apollo/client';


export const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        isLoggedIn() {
        	return isLoggedInVar();
        },
        isAlert() {
        	return alertVar();
        },
        isNotification() {
          return notificationVar();
        },
        isDisappearingAlert() {
          return disappearingAlertVar();
        },
      },
    },
  },
})


var isLoggedInFromLocal = false;

if(process.browser){
  if(window.localStorage.active){
  	isLoggedInFromLocal = true;
  }
}

export const isLoggedInVar = makeVar(isLoggedInFromLocal)
export const notificationVar = makeVar({ title:"", text:"", state:false })
export const alertVar = makeVar({ text:"", state:false })
export const disappearingAlertVar = makeVar({ text:"", state:false })
export const isApiVar = makeVar(false)


export const IS_LOGGED_IN = gql`
  query IsLoggedIn {
    isLoggedIn @client
  }
`;

export const IS_ALERT = gql`
  query IsAlert {
    isAlert @client {
      text
      state
    }
  }
`;

export const IS_NOTIFICATION = gql`
  query IsNotification {
    isNotification @client {
      title
      text
      state
    }
  }
`;

export const IS_DISAPPEARING_ALERT = gql`
  query IsDisappearingAlert {
    isDisappearingAlert @client {
      text
      state
    }
  }
`;